import { render, staticRenderFns } from "./detail-ocr.vue?vue&type=template&id=6fe55e76&scoped=true"
import script from "./detail-ocr.vue?vue&type=script&lang=js"
export * from "./detail-ocr.vue?vue&type=script&lang=js"
import style0 from "./detail-ocr.vue?vue&type=style&index=0&id=6fe55e76&prod&lang=css"
import style1 from "./detail-ocr.vue?vue&type=style&index=1&id=6fe55e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe55e76",
  null
  
)

export default component.exports